import fp from 'lodash/fp'
import { isInsideBrowser } from 'common/src/vtj/browser/browser-util'
import {
  SettingsApi,
  exposeSettingsApi,
} from 'common/src/vtj/settings/settings-api'
import {
  GlobalWithTestAppSettings,
  WindowWithAppSettings,
} from 'common/src/vtj/settings/public-settings'
import { isInsideUnitTesting } from 'common/src/vtj/settings/settings.util'

export type GlobalWithPublicSettings = typeof globalThis & {
  todistuksetUiPublicSettingsApi: SettingsApi
}

function getPublicSettings(): SettingsApi {
  if (
    !fp.isEmpty(
      (global as GlobalWithTestAppSettings).AUTOMATED_TEST_APP_SETTINGS
    )
  ) {
    return exposeSettingsApi(
      (global as GlobalWithTestAppSettings).AUTOMATED_TEST_APP_SETTINGS
    )
  } else if (isInsideBrowser() && !isInsideUnitTesting()) {
    return exposeSettingsApi((window as WindowWithAppSettings).APP_SETTINGS)
  } else {
    // inside node server / SSR or running unit testing
    return (global as GlobalWithPublicSettings).todistuksetUiPublicSettingsApi
  }
}

export default {
  getPublicSettings,
}
